import React from 'react';
import { Switch, TextField, FormControlLabel } from '@material-ui/core';
import { translate } from 'react-i18next';
import './ToggleNumericSetting.scss';

/**
 * @param {{
 *  toggleName: string;
 *  inputName: string;
 *  toggleValue: boolean;
 *  inputValue: number;
 *  isDisabled: boolean;
 *  isInputDisabled: boolean;
 *  onToggleChange?: (checked: boolean) => void;
 *  onNumberChange?: (value: number) => void;
 *  label: string|undefined;
 *  unitLabel: string|undefined;
 *  errors: *;
 *  t: *;
 * }} param0
 */
const ToggleNumericSetting = ({
    toggleName,
    inputName,
    toggleValue,
    inputValue,
    isDisabled,
    isInputDisabled,
    onToggleChange = () => {},
    onNumberChange = () => {},
    label,
    unitLabel,
    errors,
    t,
}) => {

    return (
        <div className="toggle-numeric-setting">
            <FormControlLabel
                control={
                    <Switch
                        checked={toggleValue}
                        onChange={(e) => {
                            onToggleChange(e.target.checked);
                        }}
                        color="primary"
                        disabled={isDisabled}
                        name={toggleName}
                    />
                }
                label={label}
            />
            <div className="input-field-container">
                <TextField
                    type="number"
                    value={inputValue}
                    inputProps={{
                        min: 0,
                        max: 365,
                        style: { textAlign: 'right' },
                    }}
                    onChange={(e) => {
                        const value = parseInt(e.target.value, 10);
                        onNumberChange(isNaN(value) ? 0 : value);
                    }}
                    disabled={isDisabled || isInputDisabled}
                    error={!!errors[inputName]}
                    variant="outlined"
                    size="small"
                    className="number-input"
                    name={inputName}
                />
                <span className="unit">{unitLabel || ''}</span>
                {errors && errors[inputName] && (
                    <span className="error-message" role="alert">
                        {t('globalSetup.errors.numeric')}
                    </span>
                )}
            </div>
        </div>
    );
};

export default translate('workplanManager')(ToggleNumericSetting);

